// extracted by mini-css-extract-plugin
export var circle = "styles-module--circle--fe11a";
export var circle1 = "styles-module--circle1--bb12d";
export var circle2 = "styles-module--circle2--720b2";
export var circle3 = "styles-module--circle3--f90df";